export default __webpack_public_path__ + "static/media/Play.e34c9858.svg";